// extracted by mini-css-extract-plugin
export default {"SecondaryCTA":"SecondaryCTA_SecondaryCTA__TcOTj"};